export default class DesactivarPerfilCurso {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idPerfilCurso) {
    try {
      const result = await this.#repository.desactivarPerfilCurso(idPerfilCurso)
      return result
    } catch (error) {
      throw error
    }
  }
}
